import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";

// Token storage has been removed — MSAL is now the single source of truth
// for the access token, and acquireTokenSilent gives us a fresh one on
// every request. `invalidateSession` no longer needs to do anything on
// its own; `AuthenticationFailureHandler.logout()` clears sessionStorage
// and signs out through MSAL.
const invalidateSessionAndRedirect = () => {
  invalidateSession();

  window.close();
  AuthenticationFailureHandler.logout();
};

const invalidateSession = () => {};

export { invalidateSession, invalidateSessionAndRedirect };
